const styles = {
  pageHolder: {
    paddingBottom: '80px'
  }
}

export default styles
